import { configureStore } from "@reduxjs/toolkit";
import authReducer from './authSlice';
import { baseApi } from "../store/api/baseApi";
import onlineStatusReducer from './onlineStatusSlice';


export const store = configureStore({
  reducer: {
    auth: authReducer,
    onlineStatus: onlineStatusReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});
